"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_spinners_1 = require("react-spinners");
const useTheme_1 = require("../../hooks/useTheme");
const Box_1 = require("../Box");
exports.BarLoader = react_1.forwardRef((props, ref) => {
    var _a, _b;
    const theme = useTheme_1.useTheme();
    const color = (_b = lodash_1.get(theme.colors, (_a = props.color) !== null && _a !== void 0 ? _a : 'accent')) !== null && _b !== void 0 ? _b : '#000';
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, marginBottom: "-5px", height: "5px", role: "progressbar" }, props, { children: jsx_runtime_1.jsx(react_spinners_1.BarLoader, { color: color, width: "100%", height: "100%" }, void 0) }), void 0));
});
//# sourceMappingURL=index.js.map